import { render, staticRenderFns } from "./candidateTag.vue?vue&type=template&id=ebab3458&scoped=true"
import script from "./candidateTag.vue?vue&type=script&lang=js"
export * from "./candidateTag.vue?vue&type=script&lang=js"
import style0 from "./candidateTag.vue?vue&type=style&index=0&id=ebab3458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebab3458",
  null
  
)

export default component.exports